import { getHeaders } from '../xhrRequest';
import { createAction } from 'redux-api-middleware';

export const FETCH_PAYMENT = 'FETCH_PAYMENT';
export const FETCH_PAYMENT_SUCCESS = 'FETCH_PAYMENT_SUCCESS';
export const FETCH_PAYMENT_FAILURE = 'FETCH_PAYMENT_FAILURE';

export const PAY_ORDER = 'PAY_ORDER';
export const PAY_ORDER_SUCCESS = 'PAY_ORDER_SUCCESS';
export const PAY_ORDER_FAILURE = 'PAY_ORDER_FAILURE';

export const fetchPayments = () => createAction({
    types: [
        FETCH_PAYMENT,
        {
            type: FETCH_PAYMENT_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    let payments = Object.values(json);

                    payments.sort((a, b) => {
                        if (parseInt(a.priority) < parseInt(b.priority)) return 1;
                        if (parseInt(a.priority) > parseInt(b.priority)) return -1;
                        return 0;
                    });

                    return {
                        payments: payments,
                    };
                });
            }
        },
        FETCH_PAYMENT_FAILURE
    ],
    endpoint: `/api/payment/payment-methods`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
});

export const payOrder = data => createAction({
    types: [
        PAY_ORDER,
        {
            type: PAY_ORDER_SUCCESS,
            payload: (action, state, res) => {
                console.log('PAY_ORDER_SUCCESS: ', res.headers.get('Content-Type'), res);
            },
        },
        {
            type: PAY_ORDER_FAILURE,
            payload: (action, state, res) => {
                console.log('PAY_ORDER_FAILED: ', res);
            },
        },
    ],
    endpoint: `/api/order/pay`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});